import { useCallback, useEffect, useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { useDispatch } from 'react-redux'
import * as fromActions from 'store/actions/courses.action'

import {
  ExternalCourseRansack,
  QueryCoursesArgs,
  COURSES,
  TDataCourses,
} from 'graphqlAPI'
import { IAreaModel } from 'models/area.model'
import { ChildFilterTypes } from 'enum'
import { usePaginationVariables } from 'hooks/usePaginationVariables'
import { CoursesTab } from '../../components/CoursesTab'
import { ApplyFiltersByType } from '../../types'

interface CoursesProps {
  area?: IAreaModel | null

  applyFiltersByType: ApplyFiltersByType
}

type Args = QueryCoursesArgs & {
  q2?: ExternalCourseRansack
}

export const Courses = ({ area, applyFiltersByType }: CoursesProps) => {
  const { text, perPage, page, sorts, setPerPage, setPage, setSorts, setText } =
    usePaginationVariables()
  const areaId = area?.id?.toString()
  const dispatch = useDispatch()

  const gCourse = useMemo(() => {
    const mapsFilters = {
      course_name: 'search_name',
      synchronous_course_enrol_final_state:
        'users_all_courses_enrol_synchronous_course_enrol_final_state',
    }
    return applyFiltersByType(ChildFilterTypes.Course, mapsFilters)
  }, [applyFiltersByType])

  const gUserAllCourse = useMemo(
    () => applyFiltersByType(ChildFilterTypes.UsersAllCourse),
    [applyFiltersByType]
  )

  useEffect(() => {
    setPage(1)
  }, [gCourse, setPage])

  const useVariables = useCallback(
    () => ({
      areaId,
      perPage,
      page,
      q: {
        sorts: sorts,
        search_name_cont: text,
        g: gCourse.filters,
      },
      participantsQuery: { g: gUserAllCourse.filters },
    }),
    [areaId, perPage, page, sorts, text, gCourse, gUserAllCourse]
  )

  const courseVariables = useVariables()

  const { data: dataCourses, loading: loadingCourses } = useQuery<
    TDataCourses,
    Args
  >(COURSES, {
    variables: courseVariables,
    fetchPolicy: 'cache-and-network',
  })

  const loading = loadingCourses

  const { courses } = { ...dataCourses }

  const handleDownloadCommon = (selectedRows, allSelected) => {
    dispatch({
      type: fromActions.COURSES_DOWNLOAD,
      payload: {
        allSelected,
        selectedRows,
        params: {
          searchText: text,
          usersFilter: {},
          fastFilters: {},
          areaId,
        },
      },
    })
  }

  return (
    <CoursesTab
      type={ChildFilterTypes.Course}
      areaId={areaId}
      nodes={courses?.nodes || []}
      total={courses?.nodesCount || 0}
      loading={loading}
      page={page}
      setPage={setPage}
      setText={setText}
      setSorts={setSorts}
      setPerPage={setPerPage}
      onDownloadReport={handleDownloadCommon}
    />
  )
}
